<template>
  <div>
    <div v-if="isAuthenticated" @click="logout()">
      <m-icon :icon="iconName" class="cursor-pointer copy-1-icon" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {defineComponent} from 'vue'
import mIcon from '../../Icons/Icon.vue'
import router from "@/router";

export default defineComponent({
  name: "Logout",
  components: {mIcon},
  props: {
    iconName: {
      default: 'arrow-right-square'
    },
    redirectRoute: {
      default: '{"name": "Home"}'
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "User/isAuthenticated"
    })
  },
  methods: {
    logout() {
      let form = {withoutState: true}

      let req = this.$store.dispatch("Authentication/logout", form);


      req.then(res => {
        this.$store.dispatch("Authentication/removeProfileToken", form);
        router.push(JSON.parse(this.redirectRoute))
      })
          .catch(error => {
            console.log(error)
          })


    },
  },
  mounted() {
    console.log(this.redirectRoute)
  }
})
</script>

<style scoped>

</style>